"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRandomBytes = void 0;
const crypto_js_1 = require("crypto-js");
const generateRandomBytes = (length) => {
    return crypto_js_1.lib.WordArray.random(length);
    ;
};
exports.generateRandomBytes = generateRandomBytes;
